<template>
  <div>
    <van-loading size="24px" vertical>加载中...</van-loading>
  </div>
</template>

<script>
import URL from "@/api/api";
import { UrlSearch, setLocal } from '@/utils/utils'
export default {
  data() {
    return {
      checkTimes: 0,
    }
  },
  created() {
    this.checkOpenid()
  },
  methods: {
    checkOpenid() {
      this.checkTimes = this.checkTimes + 1;
      // console.log("checkTimes:" + this.checkTimes);
      let openid = localStorage.getItem("openid");
      let appCode = UrlSearch().appCode
      let userKey = UrlSearch().userKey
      if (openid) {
        this.$fetchPost(URL.checkOpenid.url + openid + '&appCode=' + appCode + '&userKey=' + userKey).then((res) => {
          if (res.data.code == 20000) {
            setLocal("cip", res.data.data.ip);
            if (res.data.data.phoneNo) {
              this.$router.replace({ path: '/productTC', query: { appCode: UrlSearch().appCode, userKey: UrlSearch().userKey, level: '保险' } });
            } else {
              this.$router.replace({ path: '/sasalogin', query: { appCode: UrlSearch().appCode, userKey: UrlSearch().userKey } });
            }
          } else {
            this.$router.replace({ path: '/sasalogin', query: { appCode: UrlSearch().appCode, userKey: UrlSearch().userKey } });
          }
        });
      } else {
        if (this.checkTimes <= 3) {
          setTimeout(() => {
            this.checkOpenid();
            // console.log("checkTimes:" + this.checkTimes);
          }, 2000);
        }
      }
    },
  }
}
</script>

<style>
</style>